import { pluralize } from './pluralize';

// `showTotal` da paginação do antd: "Mostrando 1 a 10 de 23 resultados".
export const showTotalResults = (total: number, range: [number, number]) =>
  `Mostrando ${range[0]} a ${range[1]} de ${pluralize(
    total,
    'resultado',
    'resultados'
  )}`;
